import JobArrow from '../JobArrow';
import styles from './index.module.scss';

export interface RecruitCardProps {
  image: string;
  overlay: string;
  labelEn: string;
  label: string;
  link: string;
}

export default function RecruitCard({ image, overlay, labelEn, label, link }: RecruitCardProps) {
  return (
    <a className={styles.card} href={link} target="_blank" rel="noreferrer">
      <img className={styles.bg} src={image} alt={label} loading="lazy" />
      <img className={styles.overlay} src={overlay} alt="" loading="lazy" />
      <div className={styles.footer}>
        <span className={styles.labelEn}>{labelEn}</span>
        <span className={styles.labelZh}>
          <span>{label}</span>
          <JobArrow className={styles.arrow} />
        </span>
      </div>
    </a>
  );
}
